import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ProtectedRoute = ({ children, adminOnly = false }) => {
    const [isValid, setIsValid] = useState(null);
    const token = localStorage.getItem('token');
    const userType = localStorage.getItem('userType');

    useEffect(() => {
        const verifyToken = async () => {
            if (!token) {
                setIsValid(false);
                return;
            }

            try {
                await axios.get(`${API}/auth/verify`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                
                if (adminOnly && userType !== 'admin') {
                    setIsValid(false);
                } else {
                    setIsValid(true);
                }
            } catch (error) {
                localStorage.removeItem('token');
                localStorage.removeItem('userType');
                localStorage.removeItem('userEmail');
                setIsValid(false);
            }
        };

        verifyToken();
    }, [token, userType, adminOnly]);

    if (isValid === null) {
        return <div className="min-h-screen flex items-center justify-center">Loading...</div>;
    }

    if (!isValid) {
        return <Navigate to={adminOnly ? '/admin/login' : '/login'} replace />;
    }

    return children;
};

export default ProtectedRoute;